/* eslint-disable react-native/no-inline-styles */
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  FlatList,
  ImageBackground,
  StatusBar,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import Toast from "react-native-simple-toast";
import Image from "@components/common/Image";
import ViewShot, { captureRef } from "react-native-view-shot";
import { useDispatch } from "react-redux";
import fetch_blob from "react-native-blob-util";
import Caret from "@assets/svg/Caret";
import VideoOverlayModal from "@components/VideoOverlayModal";
import BannerSkeleton from "@components/CMS/Skeleton/BannerSkeleton";
import VideoPlayer from "@components/VideoPlayer";
import YoutubePlayer from "@components/YouTubePlayer";
import { actions } from "@reducers/miscReducer";
import handleFSPermission from "@utils/handleFSPermission";
import parseTemplate from "@utils/parseTemplate";
import { shareOnWhatsapp } from "@utils/shareEntity";
import analytics from "@services/analytics";
import entityStyle from "@utils/entityStyle";
import Download from "../../assets/svg/Download";
import Fire from "../../assets/svg/Fire";
import WhatsApp from "../../assets/svg/WhatsappSmall";
import AppText from "../../components/AppText";
import Button from "../../components/Button";
import FetchCMSEntity from "../../components/CMS/RenderCMSEntity";
import { isCLApp } from "../../config";
import metrics from "../../constants/metrics";
import useGetVideoTime, {
  GetVideoTimeContextProvider,
} from "../../utils/useGetVideoTime";
import {
  LEADER_TRAINING,
  DPG_EVENTS,
  OTHER_EVENTS,
} from "../../constants/analyticsEventsCT";
import handleCMSNavigation from "../../utils/handleCMSNavigation";
import ZoomImageShare from "../../components/CMS/ZoomImageShare";
import { normalize } from "../PlaceOrder/OssModal";
import WhatsappDefault from "../../assets/svg/WhatsappDefault";

import t from "@constants/localization";

const PATH = "screens/LeaderTraining/BannerListHorizontal";

const BannerListHorizontal = (props) => {
  const {
    cl_title,
    list_items = [],
    link_params = "",
    cms_item_id = "",
    layout_columns = 1,
    link = "",
    link_type = "",
    trackEvent = () => {},
  } = props;

  const _onlyChild = useMemo(
    () => Array.isArray(list_items) && list_items.length === 1,
    [list_items],
  );

  const _renderItem = useCallback(({ item }) => {
    return (
      <FetchCMSEntity
        fromBannerListHorizontal={true}
        onlyChild={_onlyChild}
        id={item.cms_item_id}
        type={item.type}
        trackEvent={trackEvent}
        listTitle={cl_title}
        {...item}
        layout_columns={layout_columns}
      />
    );
  }, []);

  return list_items && list_items.length ? (
    <View
      style={[
        styles.container,
        entityStyle.entityContainer,
        { borderWidth: 0, borderColor: "navy" },
      ]}
    >
      {(typeof cl_title === "string" && cl_title.trim().length) ||
      link_params ? (
        <View style={styles.titleContainer}>
          <View style={styles.halfWidth}>
            <AppText
              bold
              style={styles.title}
              numberOfLines={1}
              ellipsizeMode="tail"
            >
              {cl_title}
            </AppText>
          </View>

          {link_params ? (
            <TouchableOpacity
              style={[styles.beLikeRow, styles.viewAllProducts]}
              onPress={() => {
                handleCMSNavigation(link, link_type, {
                  cms_item_id,
                  cl_title,
                });
              }}
            >
              <>
                <AppText style={styles.primaryColor} bold>
                  {t(`${PATH}/seeAll`)}
                </AppText>
                <Caret strokeColor="#E40046" />
              </>
            </TouchableOpacity>
          ) : null}
        </View>
      ) : null}
      <FlatList
        horizontal={true}
        contentContainerStyle={styles.flatListStyles}
        showsHorizontalScrollIndicator={false}
        data={list_items}
        renderItem={_renderItem}
        keyExtractor={(item) => `key-${item.cms_item_id}`}
      />
    </View>
  ) : (
    <></>
  );
};

export const BannerListHorizontalItem = (props) => {
  const {
    title_ref = "",
    image_link = "",
    video_link = "",
    link = "",
    link_type = "",
    sharingTemplate: { image_link: sharing_image_link = "", template = "" },
    sharingLink = "",
    layout_columns = 1,
    image_dimension_width = 1,
    image_dimension_height = 1,
    sub_type = "",
    cl_title = "",
    cx_title = "",
    overlay_template_name = "",
    transparent_url = "",
    cl_subtitle = "",
    trackEvent = () => {},
    listTitle = "",
  } = props;

  const [loaded, setLoaded] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showBanner, setShowBanner] = useState(false);

  const [show, setShow] = useState(false);
  const [played, setPlayed] = useState(false);
  const dispatch = useDispatch();
  const viewShotRef = React.useRef();

  const imgSource =
    image_link.charAt(0) === "{"
      ? JSON.parse(image_link).file.response.url
      : image_link;

  useEffect(() => {
    if (show && !played) {
      setPlayed(true);
      // analytics.trackEvent(LEADER_TRAINING.VIDEO_PLAYED, {
      //   video_name: title_ref,
      // });
    }
  }, [played, show]);

  const bannerTitle = isCLApp ? cl_title : cx_title;

  const aspectRatio = image_dimension_width / image_dimension_height;
  const width = metrics.screenWidth / layout_columns - 15;
  const imageHeight = width / aspectRatio;

  const captureAndSave = () => {
    captureRef(viewShotRef, {
      result: "base64",
    }).then(async (data) => {
      const { fs } = fetch_blob;
      const { dirs } = fs;
      const file_path = `${dirs.PictureDir}/${title_ref}.jpg`;
      const base64_img = data;
      await handleFSPermission(() =>
        fs
          .createFile(file_path, base64_img, "base64")
          .then((rep) => {
            analytics.trackEvent(DPG_EVENTS.DPG_SAVE, {});
            Toast.showWithGravity(
              t(`${PATH}/photoSaved`),
              Toast.LONG,
              Toast.BOTTOM,
            );
          })
          .catch(() => {
            Toast.showWithGravity(
              t(`${PATH}/photoAlreadySaved`),
              Toast.LONG,
              Toast.BOTTOM,
            );
          }),
      );
    });
  };

  const captureAndShare = () => {
    analytics.trackEvent(DPG_EVENTS.DPG_BANNER_TAP, {
      banner_title: title_ref,
      list_title: listTitle,
    });
    analytics.trackEvent(DPG_EVENTS.DPG_SHARE, {
      banner_title: title_ref,
      list_title: listTitle,
    });
    const message = parseTemplate(template, {});
    viewShotRef.current.capture().then(async (uri) => {
      shareOnWhatsapp({
        message: `${message} ${sharingLink}?utm_source=DPG`,
        image: uri,
      });
    });
  };

  const isQuoteCard = overlay_template_name === "quotes_card";
  const imageBorderRadius = overlay_template_name === "business_card" ? 10 : 0;
  const bannerHeight = isQuoteCard ? imageHeight + normalize(80) : imageHeight;

  return (
    <>
      <ZoomImageShare
        imageHeight={image_dimension_height}
        handleShare={captureAndShare}
        toggleBanner={() => {
          setShowBanner(!showBanner);
        }}
        imageUrl={image_link}
        visible={showBanner}
      />
      <VideoOverlayModal
        visible={show}
        onClose={() => {
          setShow(!show);
          StatusBar.setHidden(false);
          StatusBar.setBarStyle("dark-content");
        }}
      >
        {sub_type === "youtube_video" ? (
          <YoutubePlayer
            {...{ title_ref, video_link, image_link }}
            inline={false}
          />
        ) : (
          <GetVideoTimeContextProvider>
            <VideoContainer
              {...{ video_link }}
              handleCta={() => {
                setShow(!show);
                StatusBar.setHidden(false);
                StatusBar.setBarStyle("dark-content");
              }}
            />
          </GetVideoTimeContextProvider>
        )}
      </VideoOverlayModal>
      <TouchableOpacity
        activeOpacity={1}
        onPress={() => {
          if (!link && video_link) {
            setShow(!show);
            StatusBar.setHidden(true);
            dispatch(actions.pauseAllVideoBanners());
          } else {
            if (overlay_template_name === "business_card") {
              captureAndShare();
              return;
            }
            if (overlay_template_name === "quotes_card") {
              analytics.trackEvent(DPG_EVENTS.DPG_BANNER_TAP, {
                banner_title: title_ref,
                list_title: listTitle,
              });
              setShowBanner(!showBanner);
              return;
            }
            setShow(false);
            handleCMSNavigation(link, link_type);
          }

          if (typeof trackEvent === "function") {
            trackEvent(OTHER_EVENTS.BANNER_CLICKED, {
              cms_item_id: props.cms_item_id,
              sub_type: "Horizontal banner list banner",
              cms_title: props.title_ref,
            });
          }
        }}
        style={[styles.bannerContainer, { width, height: bannerHeight }]}
      >
        {loading && !loaded && (
          <BannerSkeleton inner={true} height={imageHeight} />
        )}

        {overlay_template_name && (
          <View
            style={{
              minHeight: imageHeight,
            }}
          >
            {overlay_template_name === "business_card" && (
              <View
                style={{
                  position: "absolute",
                  zIndex: 1200000,
                  right: normalize(9),
                  bottom: normalize(16),
                  flexDirection: "row",
                  borderWidth: 1,
                  borderColor: "#fff",
                  borderRadius: normalize(6),
                  paddingHorizontal: normalize(10),
                  paddingVertical: normalize(2),
                }}
              >
                <WhatsappDefault />
                <Text
                  style={{
                    fontSize: normalize(12),
                    lineHeight: normalize(18),
                    fontWeight: "600",
                    color: "#fff",
                  }}
                >
                  {t(`${PATH}/share`)}
                </Text>
              </View>
            )}
            <ViewShot
              ref={viewShotRef}
              options={{ format: "jpg", quality: 0.9 }}
            >
              <ImageBackground
                source={{
                  uri: imgSource,
                }}
                style={[
                  styles.imageBackground,
                  { borderRadius: imageBorderRadius },
                  {
                    height: !loaded ? 0 : imageHeight,
                    elevation: 1,
                    overflow: "hidden",
                  },
                ]}
                onLoadEnd={() => {
                  setLoading(false);
                  setLoaded(true);
                }}
              >
                <ImageBackground
                  source={{ uri: transparent_url }}
                  resizeMode="contain"
                  style={[
                    styles.imageBackground,
                    {
                      height: imageHeight,
                      overflow: "hidden",
                    },
                  ]}
                />
              </ImageBackground>
            </ViewShot>
            {overlay_template_name === "quotes_card" && (
              <View
                style={{
                  backgroundColor: "white",
                  flexDirection: "row",
                  paddingHorizontal: normalize(12),
                  paddingVertical: normalize(8),
                  borderWidth: 1,
                  borderColor: "rgba(0, 0, 0, 0.05)",
                  marginBottom: normalize(20),
                }}
              >
                <TouchableOpacity
                  activeOpacity={1}
                  onPress={() => {}}
                  style={{
                    flex: 0.6,
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <>
                    <Fire />
                    <Text
                      style={{
                        fontSize: normalize(12),
                        color: "rgba(0, 0, 0, 0.56)",
                        marginLeft: normalize(5),
                      }}
                    >
                      {cl_subtitle}
                    </Text>
                  </>
                </TouchableOpacity>
                <TouchableOpacity
                  onPress={captureAndSave}
                  style={{
                    alignItems: "center",
                    marginHorizontal: normalize(12),
                    flex: 0.2,
                  }}
                >
                  <>
                    <Download />
                    <Text
                      style={{
                        fontSize: normalize(12),
                        color: "rgba(0, 0, 0, 0.56)",
                        marginTop: normalize(2),
                      }}
                    >
                      {t(`${PATH}/save`)}
                    </Text>
                  </>
                </TouchableOpacity>
                <TouchableOpacity
                  onPress={captureAndShare}
                  style={{
                    alignItems: "center",
                    flex: 0.2,
                  }}
                >
                  <>
                    <WhatsApp width={17} height={17} />
                    <Text
                      style={{
                        fontSize: normalize(12),
                        color: "rgba(0, 0, 0, 0.56)",
                        marginTop: normalize(2),
                      }}
                    >
                      {t(`${PATH}/share`)}
                    </Text>
                  </>
                </TouchableOpacity>
              </View>
            )}
          </View>
        )}
        {!overlay_template_name && (
          <Image
            onLoadEnd={() => {
              setLoading(false);
              setLoaded(true);
            }}
            source={{ uri: imgSource, priority: Image.priority.high }}
            style={[styles.bannerImage, { height: imageHeight, width }]}
          />
        )}
        {typeof bannerTitle === "string" && bannerTitle.trim().length ? (
          <View
            style={{
              flexDirection: "row",
              flex: 1,
              flexWrap: "wrap",
            }}
          >
            <Text
              style={styles.titleStyles}
              numberOfLines={2}
              ellipsizeMode="tail"
            >
              {bannerTitle}
            </Text>
          </View>
        ) : null}
      </TouchableOpacity>
    </>
  );
};

const VideoContainer = ({ video_link = "", handleCta = () => {} }) => {
  const [state] = useGetVideoTime();

  return (
    <>
      <VideoPlayer videoLink={video_link} />

      {state.isCompleted && (
        <View style={styles.videoStateCompleteContainer}>
          <Button
            style={styles.paddingEvenly}
            buttonWidth="100%"
            btnText="Close"
            buttonFontType="head1"
            height={56}
            borderRadius={10}
            onPress={handleCta}
          />
        </View>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    marginVertical: 10,
    // paddingBottom: 4,
  },
  beLikeRow: {
    flexDirection: "row",
  },
  viewAllProducts: {
    padding: 15,
    justifyContent: "center",
    alignItems: "center",
    paddingRight: 0,
    paddingVertical: 0,
    marginVertical: 0,
  },
  titleContainer: {
    // borderWidth: 1,
    // borderColor: 'tomato',
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "baseline",
    paddingBottom: 6,
    // paddingTop: 24,
    // paddingBottom: 10,
    // paddingHorizontal: 15,
  },
  halfWidth: {
    // width: "70%",
  },
  title: {
    lineHeight: 28,
    fontSize: 20,
  },
  primaryColor: {
    color: "#E40046",
  },

  flatListStyles: {
    paddingTop: 4,
    // paddingHorizontal: 10,
  },

  videoStateCompleteContainer: {
    position: "absolute",
    bottom: 20,
    left: 20,
    right: 20,
  },

  titleStyles: {
    color: "rgba(0,0,0,0.86)",
    fontSize: 14,
    lineHeight: 16,
    paddingTop: 12,
  },
  bannerImage: {
    // height: 9 * 12,
    // width: 16 * 12,
    borderRadius: 8,
  },
  bannerContainer: {
    marginRight: 6,
    // marginHorizontal: 6,
  },
  paddingEvenly: {
    padding: 15,
  },
});

export default BannerListHorizontal;
